// extracted by mini-css-extract-plugin
module.exports = {"modal":"InfoModal_modal__2nqah"};